export default __webpack_public_path__ + "static/media/youtube-like-png-39121.9e90e5d1.png";